{
    "warning": "ΠΡΟΣΟΧΗ!",
    "message": "Μην εισάγεις ή κάνεις επικόλληση κωδικών που δεν κατανοείς.\nΗ χρήση αυτής της κονσόλας είναι πιθανό να επιτρέψει στους εισβολείς να προσποιηθούν ότι είσαι εσύ και να κλέψουν τις πληροφορίες σου μέσω μιας επίθεσης που λέγεται Self-XSS."
}
